<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">Quản lý đơn vị</div>
      </div>
      <div class="card card-w-title" v-if="display_page">
        <div class="box-top-list">
          <span class="p-m-0">{{ titleModel }}</span>
          <span class="right-button">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
            <Button :disabled="submitForm" class="p-button-success btn-custom" :label="labelName" @click="saveData" />
          </span>
        </div>
        <div class="list-data">
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6 box-custom-form">
              <div class="p-col-8 item-custom-form">
                <label class="title-group-form">Thông tin chung</label>
               </div>
            </div>
            <div class="p-field p-col-12 p-md-6 box-custom-form">
              <div class="p-col-8 item-custom-form">
                <label class="title-group-form">Địa chỉ</label>
               </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="name">Tên đơn vị <span class="error">*</span></label>
                <InputText id="name" type="text" v-model="name" />
                <small v-if="validationErrors && validationErrors['name']"
                    class="p-invalid" >{{validationErrors['name']}}</small>
                <small v-if="name_exists"
                class="p-invalid" >Tên đơn vị bị trùng</small>
              </div>
            </div>

            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="province_id">Tỉnh/Thành phố</label>
                <v-select :filterable="false" placeholder="Chọn tỉnh/thành phố" v-model="province_id"  :options="provinces" :reduce="province => province.value"  label="label" @search="fetchOptionsProvince" @input="changeProvince">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
               <!-- <Dropdown :filter="true" placeholder="Chọn tỉnh/thành phố"  @change="changeProvince"  inputId="province_id" v-model="province_id" :options="provinces" optionLabel="label"  optionValue="value" />
             --> </div>
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <div class="p-grid">
                  <div class="p-col-6">
                    <label for="phone_number">Số điện thoại <span class="error">*</span></label>
                    <InputText id="phone_number" type="text" v-model="phone_number"/>
                    <small v-if="validationErrors && validationErrors['phone_number']"
                        class="p-invalid" >{{validationErrors['phone_number']}}</small>
                  </div>
                  <div class="p-col-6">
                    <label for="tax_number">Mã số thuế</label>
                    <InputText  id="tax_number" type="text" v-model="tax_number"/>
                    <small v-if="tax_number_exists"
                    class="p-invalid" >Mã số thuế bị trùng</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="district_id">Quận/Huyện</label>
                <v-select :filterable="false" placeholder="Chọn quận/huyện" v-model="district_id"  :options="districts" :reduce="districts => districts.value"  label="label" @search="fetchOptionsDistrict" @input="changeDistrict">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
               <!-- <Dropdown  :filter="true" placeholder="Chọn quận/huyện" @change="changeDistrict" inputId="district_id" v-model="district_id" :options="districts" optionLabel="label"  optionValue="value" />
            -->  </div>
            </div>
            
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="email">Email</label>
                <InputText  id="email" type="text" v-model="email"/>
                <small v-if="validationErrors && validationErrors['email']"
                    class="p-invalid" >{{validationErrors['email']}}</small>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="ward_id">Phường/Xã</label>
                <v-select :filterable="false" placeholder="Chọn phường/xã" v-model="ward_id"  :options="wards" :reduce="wards => wards.value"  label="label" @search="fetchOptionsWard" >
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
              <!--  <Dropdown  :filter="true" placeholder="Chọn phường/xã" inputId="ward_id" v-model="ward_id" :options="wards" optionLabel="label"  optionValue="value" />
         -->     </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="parent_id">Đơn vị cấp cha <span class="error">*</span></label>
                <v-select :clearable="false" :filterable="false" placeholder="Chọn đơn vị cấp cha" v-model="parent_id"  :options="listParents" :reduce="listParents => listParents.value"  label="label"  @search="fetchOptionsParentItem">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                </v-select>
               <!-- <Dropdown  :filter="true" placeholder="Chọn đơn vị cấp cha" inputId="parent_id" v-model="parent_id" :options="listParents" optionLabel="label"  optionValue="value" />
               --> <small v-if="validationErrors && validationErrors['parent_id']"
                       class="p-invalid" >{{validationErrors['parent_id']}}</small>
              </div>
            </div>
            
           <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="address">Số nhà</label>
                <InputText  id="address" type="text" v-model="address"/>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <div class="p-grid">
                  <div class="p-col-6">
                    <label for="unit_id">Loại đơn vị <span class="error">*</span></label>
                    <v-select :clearable="false" :filterable="false" placeholder="Chọn loại đơn vị" v-model="unit_id"  :options="settingUnits" :reduce="settingUnits => settingUnits.value"  label="label"  @input="changeUnits" @search="fetchOptionssettingUnit">
                  <span slot="no-options" @click="$refs.select.open = false">
                  {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                </span>
                    </v-select>
                  <!--  <Dropdown  :filter="true" @input="changeUnits" placeholder="Chọn loại đơn vị" inputId="unit_id" v-model="unit_id" :options="settingUnits" optionLabel="label"  optionValue="value" />
                  -->  <small v-if="validationErrors && validationErrors['unit_id']"
                           class="p-invalid" >{{validationErrors['unit_id']}}</small>
                  </div>
                  <div class="p-col-6">
                    <label for="unit_id">Loại quan hệ <span class="error">*</span></label>
                    <Dropdown   placeholder="Chọn loại quan hệ" inputId="organization_type" v-model="organization_type" :options="organizationTypes" optionLabel="label"  optionValue="value" />
                    <small v-if="validationErrors && validationErrors['organization_type']"
                           class="p-invalid" >{{validationErrors['organization_type']}}</small>
                  </div>

                </div>
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6 box-custom-form">
              <div class="p-col-8 item-custom-form">
                <label class="title-group-form">Tọa độ bản đồ</label>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <div class="p-grid">
                  <div class="p-col-6">
                    <label for="number_of_accounts">Số lượng đơn vị cấp con</label>
                    <InputNumber  id="number_of_subunits" type="text" :min="-1" v-model="number_of_subunits"/>
                    <!-- <Dropdown @input="changeNumberOfAccount" inputId="number_of_accounts" v-model="number_of_accounts" :options="numberAccounts" optionLabel="label"  optionValue="value" /> -->
                    <small v-if="validationErrors && validationErrors['number_of_subunits']"
                           class="p-invalid" >{{validationErrors['number_of_subunits']}}</small>
                  </div>
                  <div class="p-col-6">
                    <label for="number_of_accounts">Số lượng tài khoản</label>
                    <InputNumber @input="changeNumberOfAccount" id="number_of_accounts" type="text" :min="-1" v-model="number_of_accounts"/>
                    <!-- <Dropdown @input="changeNumberOfAccount" inputId="number_of_accounts" v-model="number_of_accounts" :options="numberAccounts" optionLabel="label"  optionValue="value" /> -->
                    <small v-if="validationErrors && validationErrors['number_of_accounts']"
                        class="p-invalid" >{{validationErrors['number_of_accounts']}}</small>
                  </div>
                </div>
              </div>
            </div>
            

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="latitude">Vĩ độ</label>
                <InputText  id="latitude" type="text" v-model="latitude"/>
              </div>
            </div>
            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="status">Trạng thái hoạt động <span class="error">*</span></label>
                <Dropdown  inputId="status" v-model="status" :options="optionStatus" optionLabel="label"  optionValue="value" />
              </div>
            </div>

            <div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="longitude">Kinh độ</label>
                <InputText  id="longitude" type="text" v-model="longitude"/>
              </div>
            </div>
            <!--<div class="p-field p-col-12 p-md-6">
              <div class="p-col-8">
                <label for="status">Trạng thái hoạt động <span class="error">*</span></label>
                <Dropdown  inputId="status" v-model="status" :options="optionStatus" optionLabel="label"  optionValue="value" />
              </div>
            </div>-->
            <div class="p-field p-col-12 p-md-6" v-if="unit_id == id_setting_unit_ttbh">
              <div class="p-col-8" ><!--v-if="checkVisible('users', 'active')"-->
                <label ></label>
                <div class="p-field-checkbox">
                  <Checkbox  v-model="is_receive_repair_requests" :binary="true"/><!--!checkCompany()-->
                  <label class="group-input-check">
                    <span>TTBH đủ năng lực tiếp nhận yêu cầu sửa chữa</span>
                    <!--<p>(Việc xác định tài khoản người đại diện để phục vụ cho việc quản lý nhân sự của Đơn vị cấp trên)</p>-->
                  </label>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
export default {
  data() {
    return {
      modelData: [],
      dataModel: null,
      componentKey: 0,
      modelName: 'organization',
      name: '',
      tax_number: '',
      phone_number: '',
      email: '',
      longitude: '',
      latitude: '',
      address: '',
      province_id: 0,
      district_id: 0,
      ward_id: 0,
      provinces: [],
      districts: [],
      wards: [],
      unit_id: 0,
      parent_id: 0,
      listParents: [],
      settingUnits: [],
      numberAccounts: [],
      number_of_accounts: 0,
      number_of_subunits: 0,
      number_count_accounts: 0,
      validationErrors: {},
      name_exists: false,
      organizationID: 0,
      organizationParentID: 0,
      hardcodeID: 0,
      tax_number_exists: false,
      optionStatus: [{value: 0, label: 'Ngưng hoạt động'}, {value: 1, label: 'Đang hoạt động'} ],
      organizationTypes: [{value: 'affiliate', label: 'Đơn vị trưc thuộc'}, {value: 'b2b', label: 'Quan hệ B2B'}],
      status: 1,
      statusOld: 1,//status cũ để validator
      titleModel: 'Tạo mới đơn vị',
      submitForm: false,
      organization_type: '',
      labelName: 'Tạo',
      display_page:true,
      is_receive_repair_requests:false,
      id_setting_unit_ttbh:null
    }
  },
  async mounted () {
    var vm = this;
    this.id_setting_unit_ttbh =await this.$coreService.id_setting_unit_ttbh();
    await this.settingsHardCode();
    this.settingUnits = await this.settingUnit();
    this.provinces = await this.provincesData();
    await this.organizationAccount();
    this.listParents = await this.parentItems();
    
    for (let index = 0; index < 6; index++) {
      this.numberAccounts.push({value: index, label: index});
    }
    this.dataModel = DataServices.getModel(this.modelName);
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      if (!vm.$myConstants.checkRoleGroup('organization', 'edit')){
        vm.display_page = false;
      }
      this.titleModel = 'Chỉnh sửa đơn vị';
      await this.getData(Number(this.$route.params.id));
    }else {
      if (!vm.$myConstants.checkRoleGroup('organization', 'add')){
        vm.display_page = false;
      }
    }
  },
  methods: {
    async getData(id) {
      var variables = {
        where_key: {
          id: {'_eq': id }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
      var list = data[Object.keys(data)];
      if (list != null && Object.keys(list).length) {
        var model = list[0];
        //console.log("modelmodelmodel:",model)
        this.modelData = model;
        this.labelName = 'Lưu';
        if(model.name != undefined) this.name = model.name;
        if(model.phone_number != undefined && model.phone_number != '') {
          var phone_convert = model.phone_number;
          this.phone_number = phone_convert.replace('+84', '0');
        }
        if(model.tax_number != undefined) this.tax_number = model.tax_number;
        if(model.email != undefined) this.email = model.email;
        if(model.address != undefined) this.address = model.address;
        if(model.unit_id != undefined) this.unit_id = model.unit_id;
        if(model.parent_id != undefined) this.parent_id = model.parent_id;
        if(model.number_of_accounts != undefined) this.number_of_accounts = model.number_of_accounts;
        if(!this.$myConstants.isEmpty(model.number_of_subunits)) this.number_of_subunits = model.number_of_subunits;
        if(model.status != undefined) {
          this.status = model.status;
          this.statusOld = model.status;
        }
        if(model.province_id != undefined) this.province_id= model.province_id;
        if(model.district_id != undefined) this.district_id= model.district_id;
        if(model.ward_id != undefined) this.ward_id= model.ward_id;
        if(model.longitude != undefined) this.longitude= model.longitude;
        if(model.latitude != undefined) this.latitude= model.latitude;
        this.is_receive_repair_requests = (model.receive_repair_requests == 1) ? true:false;
        this.districts = [];
        this.wards = [];
        if (this.modelData && this.modelData != null) {
          if (this.province_id > 0) this.districts =await this.districtsData(this.province_id);
          if (this.district_id > 0) this.wards =await this.wardsData(this.district_id);
        }
        var count = (model.organizations_aggregate !== undefined && model.organizations_aggregate !== null && model.organizations_aggregate.aggregate != undefined && model.organizations_aggregate.aggregate != null) ? model.organizations_aggregate.aggregate.count  : 0;
        this.number_count_accounts = count;
        this.organization_type = model.organization_type;
        this.componentKey++;
      }
    },
    backList() {
       this.$router.push({path: '/admin/organization'});
    },
    async organizationAccount() {
      var whereKey = {
        status: {'_eq': 1}
      }
      // if (this.$store.getters.fullname.user_type == 2) {
      whereKey = Object.assign(whereKey, { user_id: {'_eq': this.$store.getters.fullname.id} })
      // }
      var variables = {
        where_key: whereKey
      }

      var data = await DataServices.getList('organization_account', {"variables": JSON.stringify(variables), "fields": "user_id organization_id organization { id unit_id number_of_accounts parent_id }"});
      var list = data[Object.keys(data)];
     
      if (list && Object.keys(list).length) {
        this.organizationID = list[0].organization_id;
        this.parent_id = this.organizationID;
        // if (this.$store.getters.fullname.user_type == 2) {
        if (list[0].organization != undefined && list[0].organization != null) {
          var unitID = list[0].organization.unit_id;
          this.organizationParentID = (list[0].organization.parent_id != undefined && list[0].organization.parent_id != null) ? list[0].organization.parent_id : 0;
          if (unitID > 0) {
            // this.settingUnits = this.settingUnits.filter(a => a.value == unitID)
            //Nếu trường hợp thêm mới thì ko gán deault địa chỉ
            //this.unit_id = unitID;
            console.log("");
          }
        }
        // }
      }
    },
    async changeUnits($event) {
      if ($event > 0) {
        this.unit_id = $event;
        var item = this.settingUnits.filter(a => a.value == this.unit_id);
        if(item && Object.keys(item).length) {
          this.number_of_accounts = (item[0].item != undefined && item[0].item != null) ? item[0].item.number_of_accounts : 0;
          this.number_of_subunits = (item[0].item != undefined && item[0].item != null) ? item[0].item.number_of_subunits : 0;
        }
        // await this.parentItems();
      }
    },
    async settingsHardCode() {
      var whereKey = {
        key: {'_eq': 'ORGANIZATION_ROOT' }
      }
      var variables = {
        where_key: whereKey
      }
      var data = await DataServices.getList('settings', {"variables": JSON.stringify(variables), "fields": "value"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        this.hardcodeID = list[0].value;
      }
    },
    async settingUnit(whereAttach = null) {
      var where_key = {
        status: {'_in': [1] }
      }
      if (whereAttach){
        for (const [key, value] of Object.entries(whereAttach)) {
          where_key[key] = value;
        }
      }
      var variables = {
        where_key: where_key,
        orderBy: {
          created_date: 'desc',
          modified_date: 'desc'
        }
      }
      var data = await DataServices.getList('view_setting_unit', {"variables": JSON.stringify(variables), "fields": "id name number_of_accounts number_of_subunits"});
      var list = data[Object.keys(data)];
      var list_unit = []
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          //this.settingUnits.push({label: item.name, value: item.id, item: item});
          list_unit.push({label: item.name, value: item.id, item: item});
        }
      }
      return list_unit;
    },
    async fetchOptionssettingUnit (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.settingUnits =await this.settingUnit(whereAttact);
      }else {
        this.settingUnits = await this.settingUnit();
      }
    },
    async fetchOptionsProvince (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.provinces =await this.provincesData(whereAttact);
      }else {
        this.provinces = await this.provincesData();
      }
    },
    async provincesData(whereAttach = null) {
      var list_provinces =[];
      var list =await this.$coreService.getAllProvince(whereAttach);
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          list_provinces.push({label: item.name, value: item.id});
        }
      }
      return list_provinces;
    },
    async changeProvince() {
      this.districts = [];
      this.wards = [];
      this.district_id = 0;
      this.ward_id = 0;
      this.districts =await this.districtsData(this.province_id);
    },
    async changeDistrict() {
      this.wards = [];
      this.ward_id = 0;
      this.wards  = await this.wardsData(this.district_id);
    },
    async fetchOptionsDistrict (search, loading) {
      //console.log("searchsearch:",search);
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.districts =await this.districtsData(this.province_id,whereAttact);
      }else {
        this.districts =await this.districtsData(this.province_id);
      }
    },
    async districtsData(provinceID,whereAttach = null) {
      var list =await this.$coreService.getDistrictByIdProvince(provinceID,whereAttach)
      var list_disctrict = [];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          list_disctrict.push({label: item.name, value: item.id});
          //this.districts.push({label: item.name, value: item.id});
        }
      }
      return list_disctrict;
    },
    async fetchOptionsWard (search, loading) {
      console.log("searchsearch:",search);
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.wards =await this.wardsData(this.district_id,whereAttact);
      }else {
        this.wards =await this.wardsData(this.district_id);
      }
    },
    async wardsData(districtID,whereAttach = null) {
      var list =await this.$coreService.getWardByIdDistrict(districtID,whereAttach);
      var list_ward = [];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          list_ward.push({label: item.name, value: item.id});
          //this.wards.push({label: item.name, value: item.id});
        }
      }
      return list_ward;
    },
    async checkName() {
      this.name = this.name.trim();
      if (this.name !== undefined && this.name !== "") {
        var where = { name: {'_ilike': this.name} }
        if (this.modelData != null && this.modelData.id != undefined && this.modelData.id != null && this.modelData.id > 0) where = Object.assign(where, {id: {'_neq': this.modelData.id}})
        var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
        return data && data[Object.keys(data)].length > 0
      }
    },
    async checkTaxNumber() {
      this.tax_number = this.tax_number.trim();
      if (this.tax_number !== undefined && this.tax_number !== "") {
        var where = { tax_number: {'_eq': this.tax_number} }
        if (this.modelData != null && this.modelData.id != undefined && this.modelData.id != null && this.modelData.id > 0) where = Object.assign(where, {id: {'_neq': this.modelData.id}})
        var data = await DataServices.getList(this.modelName, {"fields": "id", "variables": JSON.stringify({where_key: where})});
        return data && data[Object.keys(data)].length > 0
      }
    },
    async validationData() {
      this.validationErrors = {};
      var checkUnit = false;
      this.tax_number_exists = false; 
      this.name_exists = false;
      if (this.unit_id > 0 && this.settingUnits != null) {
        var returnUnit = this.settingUnits.filter(a => Number(a.value) == Number(this.unit_id));
        if (returnUnit &&  Object.keys(returnUnit).length > 0) checkUnit = true
      }
      if (this.name == undefined || this.name == '') this.validationErrors['name'] = 'Nhập tên đơn vị';
      if (this.phone_number == '' || this.phone_number.length == 0)
      {
        this.validationErrors['phone_number'] = 'Nhập số điện thoại';
      }else {
        if (!this.$myConstants.validatePhone(this.phone_number,10)){
          this.validationErrors['phone_number'] = 'Nhập không đúng định dạng số điện thoại di động';
        }else {
          var phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
          var where_phone = {_or: [{phone_number: {_eq: this.phone_number.toString().trim()}},{phone_number: {_eq: phone_convert.trim()}}]}
          if (!this.$myConstants.isEmpty(this.$route.params.id)){
            where_phone.id = {_neq: this.$route.params.id};
          }
          var check_phone =await DataServices.getObjectData('organization',where_phone,null);
          if (!this.$myConstants.isEmpty(check_phone)){
            this.validationErrors['phone_number'] = 'Số điện thoại bị trùng';//Trùng tên goi dv
          }
        }
      }
      //if (this.phone_number != '' && (this.phone_number.length != 10 || isNaN(this.phone_number))) this.validationErrors['phone_number'] = 'Nhập số điện thoại không đúng định dạng';
      if (this.email != undefined && this.email != null && this.email != '' && !this.$myConstants.mailValidation(this.email)) this.validationErrors['email'] = 'Email không đúng định dạng';
      if(this.unit_id == undefined || this.unit_id == 0 || !checkUnit) this.validationErrors['unit_id'] = 'Chọn loại đơn vị';
      if(this.parent_id == undefined || this.parent_id == 0) this.validationErrors['parent_id'] = 'Chọn đơn vị cấp cha';
      if(this.status == undefined || this.status == null) this.validationErrors['status'] = 'Chọn trạng thái hoạt động';
      if(this.organization_type == undefined || this.organization_type == null || this.organization_type == '') this.validationErrors['organization_type'] = 'Chọn loại quan hệ';
      if (this.tax_number != '') this.tax_number_exists = await this.checkTaxNumber();
      this.name_exists = await this.checkName();

      var organizationIDParent = null;
      var organizationLogin = this.$myConstants.organizationUserLogin();
      var number_of_subunits_allow = 0;//số đơn vị cấp con cho phép
      if (organizationLogin && Object.keys(organizationLogin).length) {
        organizationIDParent = organizationLogin.id;
        number_of_subunits_allow = (!this.$myConstants.isEmpty(organizationLogin.number_of_subunits)) ? organizationLogin.number_of_subunits:0;
      }
      //check giời hạn số đơn vị cấp con được tạo
      var number_of_subunits_created = 0;
      if (this.$myConstants.isEmpty(this.$route.params.id)) { //trường hợp tạo mới
        number_of_subunits_created = await this.get_number_of_subunits_created(organizationIDParent);
        if (number_of_subunits_allow <= number_of_subunits_created) {
          this.$toast.add({
            severity: 'error',
            summary: 'Thông báo',
            detail: `Đơn vị đã tạo ${number_of_subunits_created}/${number_of_subunits_allow} đơn vị. Vui lòng kiểm tra lại.`,
            life: 3000
          })
          this.validationErrors['number_of_subunits_allow'] = 'Lỗi';//thêm vào để dừng validator
        }
      } else {
        //trường hợp thêm mới
        if (this.statusOld == 0 && this.status == 1) {
          number_of_subunits_created = await this.get_number_of_subunits_created(organizationIDParent);
          //nếu từ trạng thái ngưng hoạt động chuyển về đang hoạt động thì check
          if (number_of_subunits_allow <= number_of_subunits_created) {
            this.$toast.add({
              severity: 'error',
              summary: 'Thông báo',
              detail: `Đơn vị đã tạo ${number_of_subunits_created}/${number_of_subunits_allow} đơn vị. Vui lòng kiểm tra lại.`,
              life: 3000
            })
            this.validationErrors['number_of_subunits_allow'] = 'Lỗi';//thêm vào để dừng validator
          }
        }
      }
      if (!(Object.entries(this.validationErrors).length === 0)) {
        //Nếu tồn tại lỗi thì force để load validator mượt
        this.$forceUpdate();
      }
    },
    async get_number_of_subunits_created(organizationIDParent) {
      //get số đơn vị cấp con đã tạo
      //Count tổng số đơn vị cấp con đã dc tạo
      if (!this.$myConstants.isEmpty(organizationIDParent)){
        var whereKeyCount = {};
        whereKeyCount = Object.assign(whereKeyCount, {parent_id: {'_eq': organizationIDParent}});
        whereKeyCount = Object.assign(whereKeyCount, {status: {'_in': [ 1] }});//chỉ lấy trạng thái đang hoạt động
        var variablesCount = {
          where_key: whereKeyCount
        }
        var countDataQuery = await DataServices.countData(this.modelName, {"variables": JSON.stringify(variablesCount)});
        var countOrganization = countDataQuery['core_organization_aggregate']['aggregate']['count'];
        if (!this.$myConstants.isEmpty(countOrganization)){
          return countOrganization;
        }
      }
      return 0;
    },
    async saveData() {
      this.submitForm = true;
      await this.validationData();
      if (!this.name_exists && !this.tax_number_exists && Object.entries(this.validationErrors).length === 0) {
        this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var phone_convert = '';
        if (this.phone_number.length == 10) {
          phone_convert = this.$myConstants.replaceAt(this.phone_number, 0, '+84');
        }
        var params = {
          'name': (!this.$myConstants.isEmpty(this.name)) ? this.$myConstants.capitalizeFirst(this.name):'',
          'email': this.email,
          'phone_number': phone_convert,
          'address': this.address,
          'contact_name': this.name,
          'contact_phone_number': phone_convert,
          'number_of_accounts': (!this.$myConstants.isEmpty(this.number_of_accounts)) ?  this.number_of_accounts:0,
          'number_of_subunits': (!this.$myConstants.isEmpty(this.number_of_subunits)) ? this.number_of_subunits:0,
          'unit_id': this.unit_id,
          'country_id': 1,
          'province_id': this.province_id,
          'district_id': this.district_id,
          'ward_id': this.ward_id,
          'tax_number': this.tax_number,
          'parent_id': this.parent_id,
          'organization_type': this.organization_type,
          'status': this.status,
        }
        if (this.unit_id == this.id_setting_unit_ttbh){
          params.receive_repair_requests = (this.is_receive_repair_requests == true) ? 1:0;
        }else {
          params.receive_repair_requests = 0;
        }
        if (this.longitude.length != '' && !isNaN(this.longitude)) {
          params = Object.assign(params, { 'longitude': this.longitude })
        }
        if (this.latitude.length != '' && !isNaN(this.latitude)) {
          params = Object.assign(params, { 'latitude': this.latitude })
        }
        if (this.modelData != null && this.modelData.id != undefined && this.modelData.id != null && this.modelData.id > 0) {
          params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
          await DataServices.updateData(this.modelName, {"variables": JSON.stringify({data_update: params, where_key: { id: {'_eq': this.modelData.id }}})});
         
          this.$store.commit('setLoading', false);
          this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
          setTimeout(() => {
            this.$router.push({path: '/admin/organization'});
          }, 500);
        } else {
          params = Object.assign(params, { 'creator_id': this.$store.getters.fullname.id })
          params = Object.assign(params, { 'created_date': this.$myConstants.currentDate() })
          params = Object.assign(params, { 'modified_date': this.$myConstants.currentDate() })
          await DataServices.insertData(this.modelName, {"variables": JSON.stringify({objects: params})});

          this.$store.commit('setLoading', false);
          this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Cập nhật thành công', life: 3000 })
          setTimeout(() => {
            this.$router.push({path: '/admin/organization'});
          }, 500);
        }
      } else this.submitForm = false;
    },
    changeNumberOfAccount($event) {
      console.log("$event$event:",$event)
      if (this.number_count_accounts > Number($event)) {
        this.number_of_accounts = this.number_count_accounts;
      }
    },
    async fetchOptionsParentItem (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var whereAttact = {plain_name:{_like: "%"+this.$myConstants.SkipVN(search).trim()+"%"}};
        this.listParents = await this.parentItems(whereAttact);
      }else {
        this.listParents = await this.parentItems();
      }
    },
    async parentItems(whereAttach = null) {
      var listParents = [];
      //this.listParents = [];
      var whereKey = {
        status: {'_in': [1] }
      }
      if (whereAttach){
        for (const [key, value] of Object.entries(whereAttach)) {
          whereKey[key] = value;
        }
      }
      var showAll = false;
      if (this.$store.getters.fullname != undefined && this.$store.getters.fullname != null && this.$store.getters.fullname.user_type == 3) { 
        showAll = true;
      }
      else {
        // thêm điều kien là hardcode và quản lý dữ liệu cấp dưới và không có cấp trên quản lý
        if( this.$store.getters.fullname.user_level != undefined && this.$store.getters.fullname.user_level != null) {
          showAll = !(this.$store.getters.fullname.user_level.parent_id != undefined && this.$store.getters.fullname.user_level.parent_id != null && this.$store.getters.fullname.user_level.parent_id > 0);
        }

        if (this.hardcodeID != this.organizationID || (!showAll && this.hardcodeID == this.organizationID )) {
          //chỉ lấy đơn vị tài khoản đăng nhập 
          // this.organizationParentID và cấp cha
          whereKey =  Object.assign(whereKey, {id: {'_in': [this.organizationID]}});
          showAll = true;
        }
      }
      if (!showAll)   listParents = [];
      else  {
        var variables = {
          where_key: whereKey,
          orderBy: {
            name: 'asc',
            modified_date: 'desc'
          }
        }
        var data = await DataServices.getList('view_organization', {"variables": JSON.stringify(variables), "fields": "id name unit_id parent_id organization_type number_of_accounts"});
        var list = data[Object.keys(data)];
        if (list !== undefined && list !== null && Object.keys(list).length) {
          for (let index = 0; index < list.length; index++) {
            const item = list[index];
            listParents.push({label: item.name, value: item.id, item: item});
          }
          if (listParents.length == 1) {
            this.number_of_accounts = (listParents[0].item.number_of_accounts != undefined && listParents[0].item.number_of_accounts != null) ? listParents[0].item.number_of_accounts : 0;
          }
        }
      }
      return listParents;
    }
  }
}
</script>
<style lang="scss">
.box-top-list{border: 1px solid #ccc; padding: 10px; 
  span{font-size: 25px; text-align: left; display: inline-block;}
  .right-button{float: right; 
    span{font-size: 14px;}
    .p-button{border-radius: 5px; min-width: 100px; 
      &.btn-custom{ margin-left: 10px;}
      span{text-align: center;}
    }
  }
}
.box-custom-form { display: flex; padding-top: 0; padding-bottom: 0;
  .item-custom-form{display: inline-flex; align-items: center; padding-top: 0; padding-bottom: 0;
    .title-group-form{font-weight: bold; margin: 0;}
  }
}
.list-data{border: 1px solid #ccc; border-top: 0 none; padding: 20px;
  .p-field-checkbox{ position: relative;
    label {
      &.group-input-check{position: absolute;
        p{font-style: italic;}
      }
    }
  }
}
</style>